$(function() {
    var els = [];

    $('[data-button-action]').each(function() {
        init(this);
    });

    function init(el) {
        var $el = $(el);
        els.push($el);
        $el.children(':first-child').click(function(e) {
            e.stopPropagation();
            e.preventDefault();
            if (!$el.hasClass('is-open')) {
                closeAll();
            }
            $el.toggleClass('is-open');
        });
        $el.children(':not(:first-child)').click(function(e) {
            if (("noLoading" in e.target.dataset)) {
                return;
            }
            e.stopPropagation();
            $('body').addClass('is-loading');
            setTimeout(function() {
                $('body').removeClass('is-loading');
            }, 7000);
        });
    }

    $('html, body').click(function() {
        closeAll();
    });

    $(document).keyup(function(e) {
        if (e.keyCode === 27) {
            closeAll();
        }
    });

    function closeAll() {
        els.forEach(function($el) {
            $el.removeClass('is-open');
        });
    }
});